// @flow
import _ from 'lodash';
import util from 'util';


import ko from 'rgs-knockout';
import type { Observable } from 'rgs-knockout';

import { nullStep } from './step';
import type { Step, StepId, StepOptions } from './step';

import { StepsBase } from './steps-base';
import type { StepsOptions } from './steps-base';


// Steps where only one step can be open simultaniously (hence mutually exclusive)
export class StepsMutuallyExclusive extends StepsBase {
	_CurrentStep: Observable<Step>;
	_lastOpenedStep: Step;

	constructor (options: Array<StepOptions> | StepsOptions) {
		super(options);

		this._CurrentStep = ko.observable(nullStep);
		this._lastOpenedStep = nullStep;

		this._CurrentStep.subscribe((previousStep) => {
			if (previousStep.isNull()) {
				return;
			}
			this.emit('close', previousStep);
			this.emit(util.format('close-%s', previousStep && previousStep.id), previousStep);
		}, this, 'beforeChange');

		this._CurrentStep.subscribe((newStep) => {
			if (newStep.isNull()) {
				return;
			}
			this.emit('open', newStep);
			this.emit(util.format('open-%s', newStep && newStep.id), newStep);

			this._analyticsHelper.sendOpenStepEvent(newStep.id, this._withAllClosedInProgress());
		}, this, 'change');

		this.on('close', (previousStep: Step) => {
			this._lastOpenedStep = previousStep;
		});
	}

	_scrollOnTop (): boolean {
		super._scrollOnTop(...arguments);

		let scrollValue = this._scroll.peek();

		if (_.isObject(scrollValue)) {
			const {id} = this.getCurrent();

			scrollValue = ko.unwrap(scrollValue[id]);
		}

		if (scrollValue === undefined) {
			return true; //by default scroll is on
		}

		return Boolean(scrollValue);
	}

	getCurrent (): Step {
		return this._CurrentStep();
	}
	getLastOpened (): Step {
		return this._lastOpenedStep;
	}

	isOpen (id: Step | StepId): boolean {
		return this._CurrentStep() === this.get(id);
	}
	open (id: Step | StepId) {
		this._CurrentStep(this.get(id));
	}
	closeAll () {
		this._CurrentStep(nullStep);
	}
	close (id: Step | StepId) {
		if (this.isOpen(id)) {
			this.closeAll();
		}
	}
}
